import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Generic scroll-reveal wrapper: slides up + fades in once in view.
export const Reveal = ({ children, delay = 0, y = 30, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for editorial headlines.
export const MaskedLines = ({ lines, className = "", lineClassName = "", start = false, delayBase = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={start ? { y: 0 } : {}}
          transition={{ duration: 0.9, ease: EASE, delay: delayBase + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
